<script>
  import { fade } from "svelte/transition";
  export let bgClick;

  function bgClickHandler() {
    if (typeof bgClick === "function") bgClick();
    else if (typeof bgClick === "string") {
      history.pushState({}, "", bgClick);
    }
  }
</script>

<style>
  .modal_component {
    @apply absolute inset-0 overflow-auto;
  }
  .modal_wrapper {
    @apply relative w-full  justify-center min-h-full inline-block;
  }
  /* .modal {
    @apply relative;
  } */
  .backdrop {
    @apply absolute inset-0 bg-black opacity-25;
  }
</style>

<main class="modal_component" in:fade out:fade>
  <div class="modal_wrapper">
    <div class="backdrop" on:click={bgClickHandler} />
  
    <slot>
      <!-- optional fallback -->
    </slot>

  </div>
</main>
